import { idtype } from "querypieces";

export default `
...on pageBuilder_locationMap_BlockType {
	${idtype}
}
`